var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sine-wave about__video-mute",attrs:{"role":"button"},on:{"click":_vm.toggleMute}})
}
var staticRenderFns = []

export { render, staticRenderFns }